import type { WordCollection } from "../collection.types";

export const ciderEmberCollection: WordCollection = {
  id: "cider-ember",
  title: "Cider & Ember",
  icon: "fire",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 9, 1), // October 1st
  endDate: new Date(new Date().getFullYear(), 10, 1), // November 1st
  words: [
    "ash",
    "breath",
    "ceremony",
    "circle",
    "coal",
    "cool",
    "dawn",
    "flame",
    "glow",
    "moon",
    "morning",
    "night",
    "pop",
    "shadow",
    "sharp",
    "smoke",
    "spark",
    "spell",
    "steam",
    "transform",
    "vapor",
    "warm",
  ],
};
